// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1NP0j","Open":"SideDrawer_Open__dUab3","Close":"SideDrawer_Close__1WVnX","SideDrawerLogo":"SideDrawer_SideDrawerLogo__fyQcy"};